import { forwardRef } from "react";

const SectionAnchor = forwardRef(function SectionAnchor(
  { id, className = "", children },
  ref
) {
  return (
    <section id={id} ref={ref} className={className}>
      {children}
    </section>
  );
});

export default SectionAnchor;
